<template>
    <div class="main">
        <div class="list-bg"></div>
        <div class="content">
            <div class="header">
                <div class="name">首页 <span>></span> 所有线路</div>
                <div class="tag">
                    <div class="address-tag" v-show='address'>
                        <p>{{'目的地：'+ address}}</p>
                        <img :src="TagClose" alt="">
                    </div>
                    <div class="time-tag" v-show='time'>
                        <p>{{'旅行时间'+ time}}</p>
                        <img :src="TagClose" alt="">
                    </div>
                </div>
                <div class="all-routers" @click="gotoAllRouters">所有路线</div>
            </div>
            <div class="menus" >
                <div class="address-menu" >
                    <span class="name">目的地<i></i></span>
                    <div class="menu" v-for="(item, index) in menus" :key="index" @mouseenter="menuEnter(index)" @mouseleave="menuLeave">
                        <div class="menu-content" v-if='item.dname'>
                            <span>{{item.dname}}</span>
                            <img v-if="item.children" :src="Triangle" alt="" class="triangle" :class="item.active ? 'triangle-active' : ''">
                            <i class="menu-bg-hover" v-show="activeIndex===index"></i>
                        </div>
                        <div class="sub-menus" v-show="activeIndex===index">
                            <div class="sub-menu" v-for="(subItem, subIndex) in item.children" :key="subIndex" @click="menuClick(subItem)">
                                {{subItem.dname}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="time-menu" >
                    <span class="name">旅行时间<i></i></span>
                    <div class="menu-content">
                        <div class="menu" v-for="(item, index) in timeMenus" :key="index" @click='timeclick(item)'>
                            {{item.name}}
                        </div>
                    </div>
                    <div class="choose-more" @click="shadeShow=true">
                        多选
                    </div>
                </div>
                <div class="time-menus-shadow" v-show="shadeShow">
                    <span class="name">旅行时间<i></i></span>
                    <div class="menus-shadow">
                        <div class="menu-shadow" v-for="(item, index) in times" :key="index" >
                            <p class="year">{{item.year}}</p>
                            <div class="sub-time" v-for="(subItem, subIndex) in item.child" :key="subIndex" @click="timeChoose(index,subIndex)">
                                <div class="sub-time-choose" :class="timeStatus[subItem.status]"></div>
                                <p :class="'p-'+timeStatus[subItem.status]">{{subItem.name}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="choose-close" @click="shadeShow=false">
                        收起
                    </div>
                    <div class="buttons">
                        <div class="commit" @click='commit'>提交</div>
                        <div class="esc" @click="shadeShow=false">取消</div>
                    </div>
                </div>
            </div>
            <div class="router-lists-content">
                <Lists :lists="lists"></Lists>
                <p @click='more' v-if='lists && total>lists.length'>加载更多</p>
                <p v-else>没有更多...</p>
            </div>
            <div class="love">
                <div class="love-header">
                    <div class="lover-header-name">猜你喜欢</div>
                    <div class="hot-route-refresh">
                        <div class="hot-route-refresh-name" @click='change'>换一批</div>
                        <div class="hot-route-refresh-img"></div>
                    </div>
                </div>
                <div class="love-content">
                    <Lists :lists="hotlists"></Lists>
                </div>
            </div>
        </div>
        <Waring v-show='wraingshow' :waring='waringword'></Waring>
    </div>
</template>

<script>
import TagClose from '@/assets/img/tag-close.png'
import Triangle from '@/assets/img/triangle-gray.png'
import Lists from '@/components/ListsContent.vue'
import {destinationlist} from '@/api/router.js'
import { themetime, getthemelist } from '@/api/theme.js'
import {toChinesNum, sliceDate} from '@/utils/index'
import {querycontent} from '@/api/content.js'
import Waring from '@/components/warning/warning'
export default {
  data () {
    return {
      TagClose,
      Triangle,
      address: '',
      time: '',
      activeIndex: undefined,
      shadeShow: false,
      menus: [
        // {
        //   name: '极地',
        //   child: [
        //     {
        //       name: '所有'
        //     },
        //     {
        //       name: '南极'
        //     },
        //     {
        //       name: '北极'
        //     }
        //   ]
        // },
        // {
        //   name: '非洲',
        //   child: [
        //     {
        //       name: '所有'
        //     },
        //     {
        //       name: '尼日利亚'
        //     },
        //     {
        //       name: '南非'
        //     }
        //   ]
        // },
        // {
        //   name: '美洲',
        //   child: [
        //     {
        //       name: '所有'
        //     },
        //     {
        //       name: '迈阿密'
        //     },
        //     {
        //       name: '洛杉矶'
        //     }
        //   ]
        // },
        // {
        //   name: '欧洲',
        //   child: [
        //     {
        //       name: '所有'
        //     },
        //     {
        //       name: '法国'
        //     },
        //     {
        //       name: '意大利'
        //     }
        //   ]
        // }
      ],
      timeMenus: [
        {
          name: '全部'
        }
      ],
      lists: [],
      times: [
        {
          year: '2019年',
          child: [
            {
              name: '一月',
              status: 0
            },
            {
              name: '三月',
              status: 1
            },
            {
              name: '四月',
              status: 1
            },
            {
              name: '五月',
              status: 1
            },
            {
              name: '六月',
              status: 1
            },
            {
              name: '七月',
              status: 1
            },
            {
              name: '八月',
              status: 1
            },
            {
              name: '九月',
              status: 1
            },
            {
              name: '十月',
              status: 1
            },
            {
              name: '十一月',
              status: 1
            },
            {
              name: '十二月',
              status: 1
            }
          ]
        },
        {
          year: '2020年',
          child: [
            {
              name: '一月',
              status: 1
            },
            {
              name: '二月',
              status: 1
            },
            {
              name: '三月',
              status: 1
            },
            {
              name: '四月',
              status: 1
            },
            {
              name: '五月',
              status: 1
            },
            {
              name: '六月',
              status: 1
            },
            {
              name: '七月',
              status: 1
            },
            {
              name: '八月',
              status: 1
            },
            {
              name: '九月',
              status: 1
            },
            {
              name: '十月',
              status: 2
            },
            {
              name: '十一月',
              status: 1
            },
            {
              name: '十二月',
              status: 1
            }
          ]
        }
      ],
      timeStatus: {
        0: 'choose-timeout',
        1: 'choose',
        2: 'choose-active'
      },
      queylist: {
        page: 1,
        limit: 9,
        menuId: undefined,
        destId: undefined,
        time: undefined
      },
      themes: {},
      total: 0,
      hotlists: [],
      hotquery: {
        page: 1,
        limit: 3,
        ishot: true
      },
      hottotal: 0,
      waringword: '',
      wraingshow: false
    }
  },
  components: {
    Lists,
    Waring
  },
  methods: {
    gotoAllRouters () {
      this.$router.push({path: '/allRouterLists'})
    },
    menuEnter (index) {
      this.activeIndex = index
    },
    menuLeave (index) {
      this.activeIndex = undefined
    },
    timeChoose (index, subIndex) {
      let subTimes = this.times[index].child
      let subChild = subTimes[subIndex]

      if (!subChild.status) {
        this.$dialog({
          title: '温馨提示',
          content: '时间已过期，不可以选择'
        })
        return
      }
      subChild.status = (subChild.status === 1 ? 2 : 1)
    },
    getmenulist () {
      destinationlist().then(res => {
        let items = this.toTree(res.data.data.items)
        for (let i = 0; i < items.length; i++) {
          if (!items[i].children) {
            items[i].children = []
          }
        }
        this.menus = items
        console.log(this.menus)
      })
    },
    toTree (data) {
      data.forEach(function (item) {
        delete item.children
      })
      var map = {}
      data.forEach(function (item) {
        map[item.id] = item
      })
      var val = []
      data.forEach(function (item) {
        var parent = map[item.parentid]
        if (parent) {
          (parent.children || (parent.children = [])).push(item)
        } else {
          val.push(item)
        }
      })
      return val
    },
    gettime () {
      themetime().then(res => {
        if (res.data.errno === 0) {
          let times = res.data.data
          let all = []
          for (let key in times) {
            let obj = {year: key, child: []}
            times[key].forEach(element => {
              obj.child.push({
                num: element,
                name: toChinesNum(element),
                status: 1
              })
            })
            all.push(obj)
          }
          this.timeMenus = this.timeMenus.concat(all[0].child)
          if (all[1]) {
            this.timeMenus.push({name: all[1].year + '年'})
          }
          this.times = all
        } else {
          this.waringword = res.data.errmsg
          this.wraingshow = true
          setTimeout(() => { this.wraingshow = false }, 1000)
        }
      })
    },
    getthemelist () {
      getthemelist({limit: 1000}).then(res => {
        if (res.data.errno === 0) {
          this.themeMenus = res.data.data.items
          let themes = res.data.data.items
          themes.forEach(element => {
            this.themes[element.id] = element.tname
          })
          this.gettheme()
          this.gethotlist()
        } else {
          this.waringword = res.data.errmsg
          this.wraingshow = true
          setTimeout(() => { this.wraingshow = false }, 1000)
        }
      })
    },
    gettheme () {
      querycontent(this.queylist).then(res => {
        if (res.data.errno === 0) {
          let items = res.data.data.items
          for (let i = 0; i < items.length; i++) {
            items[i].time = `${sliceDate(items[i].travelBeginTime)}至${sliceDate(items[i].travelEndTime)}`

            console.log(this.themes)
            items[i].classes = this.themes[items[i].themeId]
          }
          this.lists = this.lists.concat(items)
          this.total = res.data.data.total
        } else {
          this.waringword = res.data.errmsg
          this.wraingshow = true
          setTimeout(() => { this.wraingshow = false }, 1000)
        }
      })
    },
    more () {
      this.queylist.page += 1
      this.gettheme()
    },
    timeclick (item) {
      this.time = item.name
      item.num = item.num < 10 ? '0' + item.num : item.num
      this.queylist.times = `${this.times[0].year}-${item.num}`
      this.queylist.page = 1
      this.lists = []
      this.gettheme()
    },
    commit () {
      let time = ''
      for (let i = 0; i < this.times.length; i++) {
        this.times[i].child.forEach(element => {
          if (element.status === 2) {
            console.log(time + this.times[i].year + '-' + element.num < 10 ? '0' + element.num : element.num)
            element.num = element.num < 10 ? '0' + element.num : element.num
            time += `${this.times[i].year}-${element.num},`
          }
        })
      }
      this.queylist.times = time.substr(0, time.length - 1)
      this.queylist.page = 1
      this.lists = []
      this.gettheme()
      this.shadeShow = false
    },
    menuClick (item) {
      this.address = item.dname
      this.queylist.destId = item.id
      this.queylist.page = 1
      this.lists = []
      this.gettheme()
    },
    gethotlist () {
      querycontent(this.hotquery).then(res => {
        let items = res.data.data.items
        for (let i = 0; i < items.length; i++) {
          items[i].time = `${sliceDate(items[i].travelBeginTime)}至${sliceDate(items[i].travelEndTime)}`

          console.log(this.themes)
          items[i].classes = this.themes[items[i].themeId]
        }
        this.hotlists = items
        this.hottotal = res.data.data.total
      })
    },
    change () {
      if (this.hottotal <= this.hotquery.page * 3) {
        this.hotquery.page = 1
      } else {
        this.hotquery.page += 1
      }
      this.gethotlist()
    }
  },
  created () {
    this.queylist.menuId = this.$store.state.menuid
    this.getmenulist()
    this.gettime()
    this.getthemelist()
    console.log(this.$store.status.menuname)
  }
}
</script>

<style lang="scss" scoped>
.main {
    width: 100%;
    background: #f4f4f4;
    overflow: hidden;
    .list-bg {
        width: 100%;
        height: 672px;
        background: url(../../assets/img/s-router-lists-bg.png) no-repeat center;
        background-size: cover;
    }
    .content {
        width: 1280px;
        margin: -200px auto 0;
        overflow: hidden;
    }
    .header {
        width: 100%;
        height: 60px;
        border-bottom: 1px solid #dae1e6;
        display: flex;
        align-items: center;
        background: #fff;
        .name {
            margin-left: 26px;
            color: #0080cc;
            font-weight: bold;
            span {
                color: #313131;
            }
        }
        .tag {
            display: flex;
            flex: 1;
            .address-tag, .time-tag {
                margin-left: 10px;
                display: flex;
                justify-content: center;
                align-items: center;
                padding: 9px 11px;
                background: #fffbf3;
                border: 1px solid #ff7e00;
                border-radius: 5px;
                line-height: 1;
                p {
                    font-size: 14px;
                    color: #ff7e00;
                    margin-right: 6px;
                }
            }
        }
        .all-routers {
            padding: 10px;
            font-size: 14px;
            color: #6a7176;
            border: 1px solid #bec5ce;
            border-radius: 5px;
            line-height: 1;
            margin-right: 25px;
            cursor: pointer;
            transition: 0.3s all;
            &:hover {
                background: #0080cc;
                border: 1px solid #0080cc;
                color: #fff;
                transition: 0.3s all;
            }
        }
    }
    .menus {
        width: 100%;
        padding-top: 20px;
        padding-bottom: 15px;
        border: 1px solid #eff3f5;
        position: relative;
        background: #fff;
        .address-menu {
            width: 100%;
            display: flex;
            align-items: center;
            .menu {
                font-size: 14px;
                color: #6a7176;
                font-weight: bold;
                line-height: 1;
                border: 1px solid #d6dde2;
                border-radius: 5px;
                margin-left: 17px;
                .menu-bg-hover {
                    background: url(../../assets/img/menu-bg.png) no-repeat center;
                    background-position-x: -3px;
                    background-size: 104% 100%;
                    width: 100%;
                    height: 53px;
                    position: absolute;
                    top: 0;
                    left: 0;
                    z-index: 1020;
                    transform: scale(1.08);
                }
                .menu-content {
                    cursor: pointer;
                    position: relative;
                    display: flex;
                    align-items: center;
                    padding: 8px 24px;
                    &:hover {
                        span {
                            color: #0080cc;
                            transform: color 0.3s;
                        }
                        .triangle {
                            transform: rotate(180deg);
                            transition: transform 0.3s;
                        }
                    }
                }
                span {
                    position: relative;
                    z-index: 1040;
                }
            }
            .triangle {
                width: 9px;
                height: 5px;
                margin-left: 8px;
                position: relative;
                top: -1px;
                z-index: 1040;
            }
            .sub-menus {
                width: 1232px;
                position: absolute;
                top: 68px;
                left: 24px;
                z-index: 1000;
                border: 1px solid #d6dde2;
                display: flex;
                padding: 8px 0;
                color: #6a7176;
                background: #fff;
            }
            .sub-menu {
                padding: 8px 15px;
                line-height: 1;
                &:hover {
                    background: #0080cc;
                    border-radius: 5px;
                    color: #fff;
                }
            }
        }
        .name {
            width: 64px;
            height: 30px;
            line-height: 30px;
            font-size: 16px;
            color: #6a7176;
            font-weight: bold;
            margin-left: 24px;
            text-align:justify;
            display:inline-block;
            overflow: hidden;
            vertical-align:top;
            i {
                display:inline-block;
                width:100%;
                height:0;
            }
        }
        .time-menu {
            width: 100%;
            margin-top: 24px;
            display: flex;
            align-items: center;
            .menu-content {
                flex: 1;
                display: flex;
                align-items: center;
            }
            .menu {
                margin-top: -1px;
                color: #6a7176;
                font-size: 15px;
                padding: 0 20px;
                &:hover {
                    font-weight: bold;
                    color: #0080cc;
                }
            }
            .choose-more {
                color: #6a7176;
                font-size: 12px;
                width: 48px;
                height: 23px;
                border: 1px solid #d6dde2;
                display: flex;
                justify-content: center;
                align-items: center;
                border-radius: 5px;
                margin-right: 24px;
                cursor: pointer;
                &:hover {
                    background: #0080cc;
                    border: 1px solid #0080cc;
                    color: #fff;
                    transition: 0.3s all;
                }
            }
        }
        .time-menus-shadow {
            width: 1259px;
            box-shadow: 0px 5px 10px #9e9c9c;
            position: absolute;
            top: 65px;
            left: 10px;
            z-index: 1060;
            background: #fff;
            padding: 8px 0px 65px;
            display: flex;
            .name {
                margin-left: 13px;
            }
            .menus-shadow {
                flex: 1;
            }
            .menu-shadow {
                display: flex;
                line-height: 1;
                margin: 8px 0 18px 20px;
                .year {
                    font-size: 14px;
                    color: #6a7176;
                    font-weight: bold;
                }
            }
            .choose-close {
                color: #6a7176;
                font-size: 12px;
                width: 48px;
                height: 23px;
                border: 1px solid #d6dde2;
                display: flex;
                justify-content: center;
                align-items: center;
                border-radius: 5px;
                margin-right: 24px;
                cursor: pointer;
                &:hover {
                    background: #0080cc;
                    border: 1px solid #0080cc;
                    color: #fff;
                    transition: 0.3s all;
                }
            }
            .buttons {
                width: 200px;
                position: absolute;
                left: 50%;
                bottom: 30px;
                z-index: 1020;
                display: flex;
                justify-content: space-between;
                transform: translateX(-50%);
            }
            .commit, .esc {
                width: 88px;
                height: 33px;
                background: #ff7e00;
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 14px;
                color: #ffffff;
                border-radius: 5px;
            }
            .esc {
                background: #0080cc;
            }
        }
        .sub-time {
            display: flex;
            margin-left: 20px;
            align-items: center;
            cursor: pointer;
            .sub-time-choose {
                width: 14px;
                height: 14px;
                border-radius: 2px;
                overflow: hidden;
            }
            .choose-timeout {
                background: #ededed;
            }
            .choose {
                background: #d6e1e8;
            }
            .choose-active {
                background: url(../../assets/img/check-1.png);
                background-size: cover;
            }
            p {
                font-size: 14px;
                color: #6a7176;
                margin-left: 10px;
                line-height: 1;
            }
            .p-choose-timeout {
                color: #d6dce1;
            }
        }
    }
    .router-lists-content {
        width: 100%;
        margin: 0 auto;
        background: #fff;
        p {
            font-size: 14px;
            color: #6a7176;
            font-style: italic;
            line-height: 130px;
            text-align: center;
        }
    }
    .love {
        width: 100%;
        margin-top: 24px;
        background: #fff;
        .love-header {
            height: 75px;
            display: flex;
            align-items: center;
        }
        .lover-header-name {
            flex: 1;
            font-size: 24px;
            color: #3f464c;
            font-weight: bold;
            line-height: 1;
            margin-left: 24px;
        }
        .hot-route-refresh {
            width: 200px;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            margin: 0 auto;
            margin-right: 24px;
            cursor: pointer;
            &:hover {
                .hot-route-refresh-name {
                    color: #0281cc;
                }
                .hot-route-refresh-img {
                    background: url(../../assets/img/refresh-icon.png);
                }
            }
        }
        .hot-route-refresh-name {
            font-size: 14px;
            color: #0281cc;
            font-weight: bold;
            color: #a3abb2;
        }
        .hot-route-refresh-img {
            width: 14px;
            height: 14px;
            margin-left: 6px;
            background: url(../../assets/img/refresh-icon-gray.png);
        }
        .love-content {
            margin-top: -30px;
            padding-bottom: 20px;
            margin-bottom: 20px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/lists/sRouterLists.vue